import { render, staticRenderFns } from "./EditAreaSettings.vue?vue&type=template&id=f9a423e6"
import script from "./EditAreaSettings.vue?vue&type=script&lang=js"
export * from "./EditAreaSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports